import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import {
  FETCH_TIME_ENTRIES,
  START_TIME_ENTRY, STOP_TIME_ENTRY,
  ADD_MANUAL_TIME_ENTRY, UPDATE_TIME_ENTRY, DELETE_TIME_ENTRY,
  SET_USER_HOURLY_RATE,
} from './actionTypes';
import {
  fetchTimeEntriesSuccess, fetchTimeEntriesFail,
  startTimeEntrySuccess, startTimeEntryFail,
  stopTimeEntrySuccess, stopTimeEntryFail,
  addManualTimeEntrySuccess, addManualTimeEntryFail,
  updateTimeEntrySuccess, updateTimeEntryFail,
  deleteTimeEntrySuccess, deleteTimeEntryFail,
  setUserHourlyRateSuccess, setUserHourlyRateFail,
} from './actions';

const errMsg = (e, fallback) => e?.response?.data?.message || fallback;

function* fetchTimeEntriesSaga({ payload: workOrderId }) {
  try {
    const { data } = yield call(api.get, `work-order-time-entry?workOrderId=${workOrderId}`);
    yield put(fetchTimeEntriesSuccess(data.response));
  } catch (error) {
    yield put(fetchTimeEntriesFail(errMsg(error, 'Failed to load time entries')));
  }
}

function* startTimerSaga({ payload: { workOrderId, notes, callback } }) {
  try {
    const { data } = yield call(api.post, 'work-order-time-entry/start', { workOrderId, notes });
    yield put(startTimeEntrySuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const message = errMsg(error, 'Failed to start timer');
    yield put(startTimeEntryFail(message));
    if (callback) callback(message);
  }
}

function* stopTimerSaga({ payload: { workOrderId, callback } }) {
  try {
    const { data } = yield call(api.post, 'work-order-time-entry/stop', { workOrderId });
    yield put(stopTimeEntrySuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const message = errMsg(error, 'Failed to stop timer');
    yield put(stopTimeEntryFail(message));
    if (callback) callback(message);
  }
}

function* addManualSaga({ payload: { data: payload, callback } }) {
  try {
    const { data } = yield call(api.post, 'work-order-time-entry/manual', payload);
    yield put(addManualTimeEntrySuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const message = errMsg(error, 'Failed to add time entry');
    yield put(addManualTimeEntryFail(message));
    if (callback) callback(message);
  }
}

function* updateSaga({ payload: { id, data: payload, callback } }) {
  try {
    const { data } = yield call(api.put, `work-order-time-entry?id=${id}`, payload);
    yield put(updateTimeEntrySuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const message = errMsg(error, 'Failed to update time entry');
    yield put(updateTimeEntryFail(message));
    if (callback) callback(message);
  }
}

function* deleteSaga({ payload: { id, callback } }) {
  try {
    yield call(api.delete, `work-order-time-entry?id=${id}`);
    yield put(deleteTimeEntrySuccess(id));
    if (callback) callback(null, id);
  } catch (error) {
    const message = errMsg(error, 'Failed to delete time entry');
    yield put(deleteTimeEntryFail(message));
    if (callback) callback(message);
  }
}

function* setHourlyRateSaga({ payload: { userId, hourlyRate, callback } }) {
  try {
    yield call(api.put, `cost-config/user-hourly-rate?id=${userId}`, { hourlyRate });
    yield put(setUserHourlyRateSuccess());
    if (callback) callback(null);
  } catch (error) {
    const message = errMsg(error, 'Failed to save hourly rate');
    yield put(setUserHourlyRateFail(message));
    if (callback) callback(message);
  }
}

export default function* timeEntrySaga() {
  yield takeLatest(FETCH_TIME_ENTRIES, fetchTimeEntriesSaga);
  yield takeLatest(START_TIME_ENTRY, startTimerSaga);
  yield takeLatest(STOP_TIME_ENTRY, stopTimerSaga);
  yield takeLatest(ADD_MANUAL_TIME_ENTRY, addManualSaga);
  yield takeLatest(UPDATE_TIME_ENTRY, updateSaga);
  yield takeLatest(DELETE_TIME_ENTRY, deleteSaga);
  yield takeLatest(SET_USER_HOURLY_RATE, setHourlyRateSaga);
}
